<template>
  <section id="contacts" class="t-black bg-white" itemscope  data-scroll-section> 
    <header class="w-100 t-center pd-big" itemprop="name">
      <h2 class="h1" itemprop="headline">
        <span class="text-fade-in">
          <span class="text-splitted">{{ t('contacts.title') }}</span>
        </span>
      </h2>
    </header>

    <div class="bg-grey radius-big gap-zero cols-2" itemprop="address" itemscope itemtype="https://schema.org/PostalAddress">
      <div class="col-1 pd-big">
        
        <div class="mn-b-big">
          <h3 class="">{{ t('contacts.instagram') }} 
            <a  href="https://www.instagram.com/thecommune.phuket/"  class="t-main" target="_blank" rel="noopener" >
              {{ t('contacts.instagramHandle') }}
            </a>
          </h3>
        </div>
  
        <div class="pd-big br-1px br-solid br-black-transp radius-big">
          <p class="p-big mn-b-small" itemprop="name">{{ t('contacts.name') }}</p>
          
          <address class="d-block mn-b-small" itemprop="address" itemscope itemtype="http://schema.org/PostalAddress">
            <a :href="t('contacts.addressLink')" target="_blank" rel="noopener"> 
              <span itemprop="streetAddress">{{ t('contacts.streetAddress') }}</span>, 
              <span itemprop="addressLocality">{{ t('contacts.addressLocality') }}</span>, 
              <span itemprop="addressRegion">{{ t('contacts.addressRegion') }}</span>, 
              <span itemprop="postalCode">{{ t('contacts.postalCode') }}</span>
            </a>
          </address>
          
          <span class="d-block mn-b-small" itemprop="telephone">
            <a :href="'tel:' + t('contacts.telephone')" class="t-black">{{ t('contacts.telephone') }}</a>
          </span>

          <span class="d-block mn-b-medium" itemprop="email">
            <a :href="'mailto:' + t('contacts.email')" class="t-black">{{ t('contacts.email') }}</a>
          </span>

          <a :href="t('contacts.addressLink')" target="_blank" rel="noopener" class="button hover-scale-1 t-black bg-main">
            {{ t('contacts.seeOnGoogle') }}
          </a>
        </div>
       
      </div>

     <div class="pd-thin">
        <iframe class="radius-big o-hidden h-100 w-100" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3952.6334858661976!2d98.29080421493127!3d7.828559808787166!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30502551b4a019f1%3A0x989bc4c4c59a1c63!2sTHE%20COMMUNE%20%7C%20Terrace%20%26%20Bar!5e0!3m2!1sen!2sth!4v1675674545782!5m2!1sen!2sth" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
    </div>
  </section>
</template>


<script setup>
/////////////////////////////
// COMPONENT DEPENDENCIES
/////////////////////////////
  import { ref, onMounted, watch, toRefs} from 'vue';
/////////////////////////////
// HELPERS
/////////////////////////////

/////////////////////////////
// CREATED
/////////////////////////////
  import { useI18n } from 'vue-i18n'
  
  const { t } = useI18n({ 
    useScope: 'global',
    messages: {
      "en": {
        "contacts": {
          "title": "Get in Touch with The Commune",
          "instagram": "Stay connected with us by following The Commune on Instagram:",
          "instagramHandle": "{'@'}thecommunephuket",
          "name": "The Commune – Terrace, Restaurant & Bar",
          "addressLink": "https://goo.gl/maps/9u6voKo47HTcqriB9",
          "streetAddress": "10/3 Laemsai Rd",
          "addressLocality": "Karon",
          "addressRegion": "Phuket",
          "postalCode": "83100",
          "telephone": "+66 061-370-99-35",
          "email": "hello{'@'}thecommunephuket.com",
          "seeOnGoogle": "See on Google Maps"
        }
      },
      "ru": {
        "contacts": {
          "title": "Свяжитесь с The Commune",
          "instagram": "Подписывайтесь на нашу страницу в Instagram и следите за новостями:",
          "instagramHandle": "{'@'}thecommunephuket",
          "name": "The Commune – Терраса и Бар",
          "addressLink": "https://goo.gl/maps/9u6voKo47HTcqriB9",
          "streetAddress": "10/3 Ламсай Рд",
          "addressLocality": "Карон",
          "addressRegion": "Пхукет",
          "postalCode": "83100",
          "telephone": "+66 061-370-99-35",
          "email": "hello{'@'}thecommunephuket.com",
          "seeOnGoogle": "Смотреть на Google Maps"
        }
      },
      "fr": {
        "contacts": {
          "title": "Contactez The Commune",
          "instagram": "Restez connecté avec nous en suivant The Commune sur Instagram :",
          "instagramHandle": "{'@'}thecommunephuket",
          "name": "The Commune – Terrasse et Bar",
          "addressLink": "https://goo.gl/maps/9u6voKo47HTcqriB9",
          "streetAddress": "10/3 Laemsai Rd",
          "addressLocality": "Karon",
          "addressRegion": "Phuket",
          "postalCode": "83100",
          "telephone": "+66 061-370-99-35",
          "email": "hello{'@'}thecommunephuket.com",
          "seeOnGoogle": "Voir sur Google Maps"
        }
      },
      "de": {
        "contacts": {
          "title": "Kontaktieren Sie The Commune",
          "instagram": "Bleiben Sie mit uns in Verbindung, indem Sie The Commune auf Instagram folgen:",
          "instagramHandle": "{'@'}thecommunephuket",
          "name": "The Commune – Terrasse und Bar",
          "addressLink": "https://goo.gl/maps/9u6voKo47HTcqriB9",
          "streetAddress": "10/3 Laemsai Rd",
          "addressLocality": "Karon",
          "addressRegion": "Phuket",
          "postalCode": "83100",
          "telephone": "+66 061-370-99-35",
          "email": "hello{'@'}thecommunephuket.com",
          "seeOnGoogle": "Auf Google Maps ansehen"
        }
      },
      "it": {
        "contacts": {
          "title": "Mettiti in contatto con The Commune",
          "instagram": "Rimani connesso con noi seguendo The Commune su Instagram:",
          "instagramHandle": "{'@'}thecommunephuket",
          "name": "The Commune – Terrazza e Bar",
          "addressLink": "https://goo.gl/maps/9u6voKo47HTcqriB9",
          "streetAddress": "10/3 Laemsai Rd",
          "addressLocality": "Karon",
          "addressRegion": "Phuket",
          "postalCode": "83100",
          "telephone": "+66 061-370-99-35",
          "email": "hello{'@'}thecommunephuket.com",
          "seeOnGoogle": "Vedi su Google Maps"
        }
      },
      "zh": {
        "contacts": {
          "title": "与The Commune取得联系",
          "instagram": "通过在Instagram上关注The Commune与我们保持联系:",
          "instagramHandle": "{'@'}thecommunephuket",
          "name": "The Commune – 露台和酒吧",
          "addressLink": "https://goo.gl/maps/9u6voKo47HTcqriB9",
          "streetAddress": "10/3 Laemsai Rd",
          "addressLocality": "Karon",
          "addressRegion": "Phuket",
          "postalCode": "83100",
          "telephone": "+66 061-370-99-35",
          "email": "hello{'@'}thecommunephuket.com",
          "seeOnGoogle": "在Google地图上查看"
        }
      }
    }
  })

  const videoElement = ref(null)

  var isPlaying = false;

  function  checkAndPlayVideo() {
    // Initializing values

    // On video playing toggle values
    videoElement.value.onplaying = function() {
        isPlaying = true;
    };

    // On video pause toggle values
    videoElement.value.onpause = function() {
        isPlaying = false;
    };  
  }

  // Play video function
  async function playVid() {      
      if (videoElement.value.paused && !isPlaying) {
          return videoElement.value.play();
      }
  } 
  
  onMounted(() => {
    // checkAndPlayVideo()
    // playVid()
  })
/////////////////////////////
// MOUNTED
/////////////////////////////
</script>

<style lang="scss">


	@media screen and (max-width: 1280px) {
    #contacts {
  		.cols-2 {
  	    .col-1 {
  	     	order: 2
  	    }

  	    .col-2 {
  	      order: 1;
  	      min-height: 33vh;
          padding-bottom: 0!important;
  	    }
  	  }
    }
	}
</style>